import { Case } from 'services';
export const CaseVideoMock: Case[] = [
  {
    id: 'CV-001',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      titleId: 'BC4B',
      displayName: 'Test'
    },
    subject: {
      subjectId: '1',
      subjectType: 'Video',
      subjectValue: 'https://www.w3schools.com/tags/movie.ogg',
      subjectLabels: [],
      subjectOwners: [
        {
          userId: '0001',
          userType: 'Xuid',
          username: 'testgamertag1'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: {
        link: 'https://www.xbox.com/en-US/',
        frames: [
          { time: 1, image: 'https://www.w3schools.com/html/pic_trulli.jpg', trait: 'house' },
          { time: 5, image: 'https://www.w3schools.com/html/img_chania.jpg', trait: 'trait' },
          { time: 10, image: 'https://www.w3schools.com/html/img_chania.jpg', trait: 'trait' }
        ]
      }
    },
    caseEvidence: {
      url: 'localhost.com',
      type: 'mp4'
    },
    caseCreationDateTime: '2019-11-07T19:35:52.1725026Z',
    caseAssignedStartTime: '2019-11-07T19:35:52.1728898Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {
      type: 'username',
      payload: {
        id: 'cid-00000000566b6c4c',
        username: 'Test First Test last',
        locale: '',
        profileImageUri:
          'https://cid-00000000566b6c4c.users.storage.live.com/users/0x00000000566b6c4c/myprofile/expressionprofile/profilephoto:Win8Static,UserTileMedium,UserTileStatic/MeControlXXLUserTile?ck=1&ex=24'
      }
    },
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  },
  {
    id: 'CV-002',
    tenant: {
      displayName: 'XboxLive',
      tenantId: '488296E409C5C8B9',
      stackingConfigurationByTitleId: {
        Moderation: {
          enabled: true,
          lookbackWindowInDays: 180,
          maxPoints: 8
        },
        Investigation: {
          enabled: false,
          lookbackWindowInDays: 365,
          maxPoints: 8
        }
      }
    },
    title: {
      displayName: 'Test',
      titleId: 'BC4B'
    },
    subject: {
      subjectId: '2',
      subjectType: 'Video',
      subjectValue: 'https:www.w3schools.com/tags/movie.mp4',
      subjectLabels: [],
      subjectOwners: [
        {
          userId: '0001',
          userType: 'Xuid',
          username: 'testgamertag1'
        }
      ],
      subjectHashes: undefined,
      subjectMetadata: undefined
    },
    caseEvidence: {
      url: 'localhost.com',
      type: 'mp4'
    },
    caseCreationDateTime: '2019-11-07T19:35:52.1725026Z',
    caseAssignedStartTime: '2019-11-07T19:35:52.1728898Z',
    caseClosedDateTime: '0001-01-01T00:00:00',
    status: 'Open',
    caseContext: {
      type: 'username',
      payload: {
        id: 'cid-00000000566b6c4c',
        username: 'Test First Test last',
        locale: '',
        profileImageUri:
          'https://cid-00000000566b6c4c.users.storage.live.com/users/0x00000000566b6c4c/myprofile/expressionprofile/profilephoto:Win8Static,UserTileMedium,UserTileStatic/MeControlXXLUserTile?ck=1&ex=24'
      }
    },
    opinion: {},
    caseActions: [],
    feedbacks: [],
    groundTruthCaseActions: false,
    outOfSla: false
  }
];
